import { useState, useEffect } from 'react';

// move to use live types + have enum for pause, reset timer.
export interface setTimerInterface {
  startTime: number;
  durationSeconds: number;
}

interface LiveTimerProps {
  timer: Date | null;
}

export const useLiveTimer = (props: LiveTimerProps) => {
  const { timer } = props;
  const [timeLeft, setTimeLeft] = useState<number>(0);
  useEffect(() => {
    const updateRemainingTime = () => {
      if (!timer) {
        return;
      }
      const dateNow = new Date();
      const endTime = new Date(timer);
      const msRemaining = endTime.getTime() - dateNow.getTime();
      if (msRemaining <= 0) {
        setTimeLeft(0);
        return;
      }
      setTimeLeft(msRemaining);
    };
    updateRemainingTime();
    const interval = setInterval(updateRemainingTime, 1000);
    return () => clearInterval(interval);
  }, [timer]);
  const seconds = Math.floor((timeLeft / 1000) % 60)
    .toString()
    .padStart(2, '0');
  const minutes = Math.floor(timeLeft / (1000 * 60))
    .toString()
    .padStart(2, '0');
  const showRed = seconds === '00' && minutes === '00';
  return { seconds, minutes, showRed, timeLeft };
};
